import * as TYPES from './action-types';

export const setGlobalTraits = data => ({
  type: TYPES.SET_GLOBAL_TRAITS,
  data,
});

